var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"flat":"","full-width":"","no-title":"","locale":_vm.locale},model:{value:(_vm.focus),callback:function ($$v) {_vm.focus=$$v},expression:"focus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }